export const USA = { id: 1, name: 'United States of America' };
export const Canada = { id: 39, name: 'Canada' };

export const StateSelectCountries = [USA, Canada];
